import React, { Component } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Message } from "primereact/message";
import i18n from "../i18n";
import { UserService } from "../service/UserService";
import { Link } from "react-router-dom";

import AuthService from "../service/AuthService";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        {i18n.t("users.required")}
      </div>
    );
  }
};

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);


    this.state = {
      username: "",
      password: "",
      loading: false,
      message: "",
    };

    // console.log('PROOOPS', this.props);

    this.userInfo = new UserService();

  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true,
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.login(this.state.username, this.state.password).then(
        () => {


          this.props.history.push("/");
          window.location.reload();

        },
        (error) => {
          this.setState({
            loading: false,
            message: i18n.t("users.invalid_login"),
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  // logo settings
  render() {
    const header = <img style={{ width: '380px', padding: '20px' }} src="assets/layout/images/demo-logo.png" />;

    return (
      <div className="p-grid p-justify-center login-page">
        <div className="box">
          <Card
            title="Login"
            className="ui-card-shadow"
            header={header}
          >
            <div className="login-panel-content">
              <Form
                onSubmit={this.handleLogin}
                ref={(c) => {
                  this.form = c;
                }}
              >
                <div className="p-fluid">
                  <label htmlFor="username"> {i18n.t("users.username")}</label>
                  <div className="p-field ">
                    <InputText
                      id="username"
                      type="text"
                      name="username"
                      size={30}
                      value={this.state.username}
                      onChange={this.onChangeUsername}
                      validations={[required]}
                    />
                  </div>

                  <div className="p-field ">
                    <label htmlFor="password">{i18n.t("users.password")}</label>
                    <InputText
                      size={30}
                      id="password"
                      name="password"
                      type="password"
                      value={this.state.password}
                      onChange={this.onChangePassword}
                      validations={[required]}
                    />
                  </div>
                  <br></br>
                  <span className="">
                    <Button id="login" label={i18n.t("users.log_me")}></Button>
                  </span>
                </div>

                {this.state.message && (
                  <div style={{ marginTop: "10px" }}>
                    <Message severity="error" text={this.state.message}></Message>
                  </div>
                )}
                <CheckButton
                  style={{ display: "none" }}
                  ref={(c) => {
                    this.checkBtn = c;
                  }}
                />
              </Form>
            </div>
            {/* <p>Nemate nalog? <Link to='register'>Kreirajte nalog</Link>.</p> */}
            <p><Link to='request-password-reset/'>Zaboravili ste lozinku?</Link></p>
          </Card>
        </div>

      </div>


    );
  }
}
